import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=84c4b37e&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84c4b37e')) {
      api.createRecord('84c4b37e', component.options)
    } else {
      api.reload('84c4b37e', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=84c4b37e&", function () {
      api.rerender('84c4b37e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2iZFcx0xHD1aS/JS/comp/openstreetmap.vue"
export default component.exports